import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPage() {
    return (
        <LegalPage title="Privacy Policy">
            <div className="space-y-5 text-lg leading-relaxed">
                <p>
                    ClearCursor is a small accessibility site. We keep the amount
                    of personal information we handle to a minimum.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    1. What we store on your device
                </h2>
                <p>
                    Your cursor preferences (colour, size, trail on/off, click-ring
                    on/off) are saved in your browser's <em>localStorage</em>. This
                    data never leaves your device and we cannot read it. Clear your
                    browser storage to remove it.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    2. What we do not collect
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                    <li>We do not require accounts, logins, or email addresses to use the tool.</li>
                    <li>We do not sell or share any personal data.</li>
                    <li>We do not run advertising trackers.</li>
                </ul>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    3. Payments
                </h2>
                <p>
                    If you choose to leave a voluntary tip, payment is processed by
                    Stripe. Stripe collects your card details and billing
                    information directly — we never see or store them. We keep a
                    small record of the transaction (session id, amount, timestamp,
                    status) so we can support refund requests.
                    See{" "}
                    <a
                        href="https://stripe.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline"
                    >
                        Stripe's Privacy Policy
                    </a>.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    4. Analytics
                </h2>
                <p>
                    We use anonymised traffic analytics to understand which parts
                    of the site are used. These do not identify you personally. If
                    you use a tracker blocker, the site still works as normal.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    5. Your rights
                </h2>
                <p>
                    You can email
                    {" "}<a href="mailto:chrisparker@gmail.com" className="underline">
                        chrisparker@gmail.com
                    </a>{" "}
                    to ask us to delete any payment record we hold about you, or
                    to confirm what data (if any) we have on file. We reply within
                    30 days.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    6. Children
                </h2>
                <p>
                    ClearCursor is a general-audience site. We do not knowingly
                    collect information from children under 13.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    7. Contact
                </h2>
                <p>
                    Privacy questions? Email
                    {" "}<a href="mailto:chrisparker@gmail.com" className="underline">
                        chrisparker@gmail.com
                    </a>.
                </p>
            </div>
        </LegalPage>
    );
}
